module.exports = __webpack_public_path__ + "img/LOGO-4.a972a8e3.png";